<template>
	<div>
		<div class="container-fluid">
			<!-- <div class="row">
				<div class="col-12 col-xl-10">
					<div class="row align-items-center justify-content-between">
						<div class="col-12 col-lg-4">
							<h3 class="mt-0 mb-4 pb-2 pt-2">{{ organization_data.name }}</h3>
						</div>
					</div>
				</div>
			</div> -->
			
			<div class="row">
				<div class="col margin-bottom-agency-actions">
					
					
					<div class="row">
						<div class="col-12">
					
							<b-card no-body class="custom-tabs">
							  <b-tabs class="white_tab" v-model="tabIndex" card>
								<b-tab title="HHAs">
									<provider-list v-if="agency!=''" :agency="agency" :AgencyView="AgencyView"></provider-list>
							    </b-tab>
								<b-tab title="Info">
										
									<form @submit.prevent="onSubmit" class="mb-5">
										<div class="row flex-nowrap">
											<div class="col-12">
												<div class="lightgray-content p-3 rounded mb-2">
													<div class="row flex-nowrap">
														<div class="agency-detail-column">
															<div class="form-group input-content">
																	<label>Agency Logo</label>
																	<picture-input 
																	v-if="tabIndex == 1"
																	ref="pictureInput"
																	accept="image/jpeg,image/png" 
																	size="10" 
																	button-class="button"
																	:custom-strings="{
																		upload: '<h1>Bummer!</h1>',
																		drag: 'Drag or click to upload an image'
																	}"
																	@change="onChange"
																	:prefill="organization_data.image_fill">
																	</picture-input>
																</div>
														</div>
														<div class="agency-detail-column">
															<div class="form-group input-content">
																<div class="form-group input-content">
																	<label>Agency Name</label>
																	<input placeholder="Name" type="text" v-model="organization_data.name" 
																	
																	class="form-control" v-validate="'required'" name="name">
																	<span class="input-error-msg">{{ errors.first('name') }}</span>
																</div>
																<div class="form-group input-content">
																<label>Agency Name As Shown On the App</label>
																	<input placeholder="Name" type="text" v-model="organization_data.display_name" 
																	
																	class="form-control"  name="internal_name">
																	<!-- <span class="input-error-msg">{{ errors.first('name') }}</span> -->
																</div>
																<div class="form-group input-content">
																	<phone-country-code
																	:rule="'not_required'"
																	:section="'existin-provider'"
																	:country_codes="country_codes"
																	:form="organization_data"
																	@countryInput="countryInput"/>
																</div>
																<div class="form-group input-content">
																	<label>Time Zone</label>
																	<v-select name="time_zone" :options="time_zones" label="name" v-model="time_zone_selected">
																	</v-select>
																</div>
																
															</div>
															
														</div><!--col-->
														
														<div class="agency-detail-column">
															<!-- <div class="form-group input-content">
																<label>Year founded</label>
																<multiselect v-model="organization_data.year_founded" :options="years" :allow-empty="false" :show-labels="false"></multiselect>
																<span class="input-error-msg">{{ errors.first('year_founded') }}</span>
															</div> -->
															<div class="form-group input-content">
																<label>Purchased hours</label>
																<!-- 
																<input placeholder="Purchased hours" type="text" 
																:disabled="user_role==='csm'" v-model="organization_data.purchased_hours" class="form-control" v-validate="" name="purchased_hours">
																<span class="input-error-msg">{{ errors.first('purchased_hours') }}</span>

																<p class="text-right">
																	Hours spent : {{ organization_data.hours_wasted }}
																</p> -->

															<div class="mt-2" v-if="organization_data.hours">
																<div>
																	<div class="bold-title">
																		<img class="img-font-size mb-1" id="" src="../../../assets/images/access_time_u27.svg"/> 
																		<input v-if="user_role == 'admin'"
																		v-model="organization_data_purchased_hours" class="purchased_hours" type="number" />
																		<span class="inline-block" v-else>
																			{{secondsToHms(organization_data.hours.purchased.sec,true)}}
																		</span>
																	</div>
																</div>
																<div class="top-item padding-cart-top">
																	<div class="cart-bar">
																		<div class="cart-bar-progress" v-bind:style="{ width:left_hours_percentage + '%' }"></div>
																	</div>
																</div>
																<div class="blue-text top-item">
																	<img class="img-font-size" id="" src="../../../assets/images/u24_circle.svg"/> {{secondsToHms(organization_data.hours.spent.sec, true) || '0h'}}
																	used
																</div>
																<div class="grey-text top-item">
																	<img class="img-font-size" id="" src="../../../assets/images/u25_circle.svg"/>  {{secondsToHms(organization_data.hours.left.sec, true)}}
																	left
																</div>
																	
															</div>
													
															</div>
														
														

															<!-- <div class="form-group input-content">
																<label>Code</label>
																<input placeholder="Internal code" type="text" v-model="organization_data.code" class="form-control" v-validate="" name="code">
																<span class="input-error-msg">{{ errors.first('code') }}</span>
															</div> -->
															<div class="form-group input-content">
																<label>Became customer on</label>
																
																<datetime v-model="organization_data.became_costumer" hidden-name="became_costumer" placeholder="Became customer on" ></datetime>
																<span class="input-error-msg">{{ errors.first('became_costumer') }}</span>
															</div>
															<div class="form-group">
																<div class="checkbox-container squared">
																	<input id="checkbox-can-download-certificate" 
																	type="checkbox" v-model="organization_data.can_download_certificate"/>
																	<label for="checkbox-can-download-certificate" style="width:auto;">HHAs can download certificate from APP</label>
																</div>
															</div>
															<div class="form-group">
																<div :class="{'input-disabled': user_role == 'csm'}" class="checkbox-container squared">
																	<input id="checkbox-can-hide-hours" 
																	:disabled="user_role==='csm'" type="checkbox" v-model="organization_data.hide_purchased_hours"/>
																	<label for="checkbox-can-hide-hours" style="width:auto;">Hide Purchased Hours from Agency Panel</label>
																</div>
															</div>


															<div class="form-group">
																<div :class="{'input-disabled': user_role == 'csm'}" class="checkbox-container squared">
																	<input id="checkbox-hide-report" 
																	:disabled="user_role==='csm'" type="checkbox" v-model="organization_data.hide_from_reports"/>
																	<label for="checkbox-hide-report" style="width:auto;">Hide from Reports</label>
																</div>
															</div>
															<div class="form-group">
																<div :class="{'input-disabled': user_role == 'csm'}" class="checkbox-container squared">
																	<input id="checkbox-hide-cs-panel" 
																	:disabled="user_role==='csm'" type="checkbox" v-model="organization_data.hide_from_panels"/>
																	<label for="checkbox-hide-cs-panel" style="width:auto;">Hide from CS panel</label>
																</div>
															</div>
														
															
														
														</div><!--col-->

														<div class="agency-detail-column">
															<h6><u>Agency Contact Detail</u></h6>
															<div class="form-group input-content">
																<label>Contact Name</label>
																<input placeholder="Name" type="text" v-model="organization_data.contact_name" 
																class="form-control" name="agency_contact_name">
															</div>
															<div class="form-group input-content">
																<label>Contact Job Title</label>
																<input placeholder="Job Title" type="text" v-model="organization_data.contact_job_title" 
																class="form-control" name="agency_contact_job_title">
															</div>
															<div class="form-group input-content">
																<label>Contact Email</label>
																<input placeholder="Name" type="text" v-model="organization_data.contact_email" 
																class="form-control" name="agency_contact_email">
															</div>
														
															<div class="form-group input-content">
																<label>Contact Phone number</label>
																<input placeholder="Phone number" type="text" v-model="organization_data.contact_phone" class="form-control"  name="phone">
															</div>

														</div><!--col-->




														<div class="agency-detail-column">
															<div class="form-group input-content">
															<label>Integrate With</label>
															<v-select name="integration_options" :options="integration_list" label="name"
																v-model="temp_partner_id"
															>
																</v-select>
															</div>
														</div>
													</div><!--row-->
												
												<div class="text-right">
													<a v-if="user_role!='csm'"  class="button red-content large-button"  @click="showModalDelete(item)">
														<img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash_white.svg">
														<span> Delete agency</span>
													</a>
													<button type="submit" 
													
													class="large-button button">Update</button>
												</div>
											</div><!--lightgray-->
											</div>
										</div><!--row-->
									</form>

								</b-tab>
							
								<b-tab title="Report">
									<div v-if="tabIndex == 2">
										<organization-report-list-component :organization_id="this.id"></organization-report-list-component>
									</div>
								</b-tab>
							    <b-tab title="Programs">
							      <!-- PROGRAMS -->
									
									<p class="text-uppercase mb-1  mb-2 d-flex align-items-center">
										<strong class="h4 m-0">Programs</strong>
										<button type="button" class="ml-2 button buttton-small small-button" @click="openAddCourseModal()">
									    	<img src="../../../assets/images/icons/solid/plus_white.svg" width="14" />
											new
										</button>

										<button type="button" class="ml-2 button buttton-small small-button" @click="show_sort_courses = !show_sort_courses">
									    	<img src="../../../assets/images/icons/solid/sort_white.svg" width="14" />
											order
										</button>
									</p>
									<div class="row justify-content-between align-items-end mb-2">
										<div class="col-12 col-md-4">
											<div class="input-content no-border m-0 ml-2">
												<input class="m-0" v-model="search_courses" placeholder="Search by program" type="text" @keyup="getCourses()" />
											</div>
										</div><!--col-->
									</div>
									
									<agency-tables :table_info="courses_table" :table_name="'courses'" :table_headers="['ID','Name','Notes','HHAs','Hours','Operational', 'Non Payable', 'Pay Code', 'Delayed Pay','Actions']" :table_body_data="courses"
									@changeCoursesPerPage="changeCoursesPerPage" @setPageCourses="setPageCourses"
									@showModalMoveToCourse="showModalMoveToCourse" @showModalDeleteCourse="showModalDeleteCourse"
									:pagination_section="true"
									></agency-tables>
									
							    </b-tab>
					
							    <b-tab title="Roles and Permissions">
							    	<!-- <p class="text-uppercase d-flex mb-2 flex-wrap align-items-center">
										<strong class="h4 m-0">Roles</strong>
										<button  v-if="user_meta_actions.includes('can_create_edit_roles')" type="button" class="ml-2 button buttton-small small-button" @click="show_add_subrole = !show_add_subrole">
									    	<img src="../../../assets/images/icons/solid/plus_white.svg" width="14" />
											new
										</button>
									</p> -->
									<b-tabs card v-model="subrole_active_tab">
										<template v-for="subrole_type in subrole_types">
											
											<b-tab :title="subrole_type.label">
												<p class="text-uppercase d-flex mb-2 flex-wrap align-items-center">
													<strong class="h4 m-0">{{subrole_type.label}}</strong>
													<button v-if="subrole_type.label == 'Users'" type="button" class="ml-2 button buttton-small small-button" @click="show_add_subrole = !show_add_subrole">
														<img src="../../../assets/images/icons/solid/plus_white.svg" width="14" />
														new
													</button>
												</p>
												<!-- <label class="ml-2">
								                	<div class="checkbox-container" v-for="config in subrole_config" v-if="config.subrole_type == subrole_type.value" :class="{ 'input-disabled' : subroles_filtered.length < 1 }">
								                    	<input type="checkbox" :id="'mandatory-' + subrole_type.value" :name="'mandatory-' + subrole_type.value" :checked="subroles_filtered.length < 1 ? 0 : config.mandatory == 1" :disabled="subroles_filtered.length < 1 ">
								                    	<label :for="'mandatory-' + subrole_type.value" 
								                    	@click="toggleMandatory(subrole_type.value)" style="margin: 0 0 0.5rem">Is mandatory </label> 
								                	</div>
								                </label> -->
												<div v-if="subrole_type.label == 'Users'">
													<agency-tables :table_name="'roles_permissions'" :table_headers="subrole_type.table_headers" :table_body_data="organization_users"
													:subrole_type="subrole_type"
													@showModalEditSubrole="showModalEditSubrole" @showModalReplaceSubrole="showModalReplaceSubrole"
													@resetPasswordSendEmail="resetPasswordSendEmail"
													@resetPasswordPlain="resetPasswordPlain"
													@showModalDeleteSubrole="showModalDeleteSubrole"
													@setSubroleAsDefault="setSubroleAsDefault"
													:pagination_section="false"
													
													></agency-tables>
												</div>
												<div v-else>
													<access-group-tree />
												</div>
												
											</b-tab>
										</template>
									</b-tabs>	
							    </b-tab>
							    <b-tab title="Disciplines">
							    	<p class="text-uppercase d-flex mb-2 flex-wrap align-items-center">
										<strong class="h4 m-0">Disciplines</strong>
										<button type="button" class="ml-2 button buttton-small small-button" @click="openAddModal('Discipline')">
									    	<img src="../../../assets/images/icons/solid/plus_white.svg" width="14" />
											new
										</button>
									</p>

									<label class="ml-2">
					                	<div class="checkbox-container">
					                    	<input type="checkbox" :checked="organization_data.discipline_mandatory == 1" id="discipline-mandatory">
					                    	<label for="discipline-mandatory" style="margin: 0 0 0.5rem"  @click="toggleTaxonomyMandatory('discipline')">Is mandatory </label> 
					                	</div>
					                </label>
									<agency-tables :table_name="'discipline'" :table_headers="['Name', 'Actions']" :table_body_data="disciplines" :pagination_section="false"
									@modalEditTaxonomyValue="modalEditTaxonomyValue"
									@modalDeleteTaxonomyValue="modalDeleteTaxonomyValue"
									@></agency-tables>

							    </b-tab>
							    <b-tab title="Locations">
							    	<p class="text-uppercase d-flex mb-2 flex-wrap align-items-center">
										<strong class="h4 m-0">Locations</strong>
										<button type="button" class="ml-2 button buttton-small small-button" @click="openAddModal('Location')">
									    	<img src="../../../assets/images/icons/solid/plus_white.svg" width="14" />
											new
										</button>
									</p>
									<label class="ml-2">
					                	<div class="checkbox-container">
					                    	<input type="checkbox" :checked="organization_data.location_mandatory == 1" id="location-mandatory">
					                    	<label for="location-mandatory" style="margin: 0 0 0.5rem"  @click="toggleTaxonomyMandatory('location')">Is mandatory </label> 
					                	</div>
					                </label>
									
									<agency-tables :table_name="'location'" :table_headers="['Name', 'Actions']" :table_body_data="locations" :pagination_section="false"
									@modalEditTaxonomyValue="modalEditTaxonomyValue"
									@modalDeleteTaxonomyValue="modalDeleteTaxonomyValue"
									@getLocations="getLocations"
									@></agency-tables>
							    </b-tab>
							    <b-tab v-if="organization_data.partner_id != 'None' && organization_data.partner_id != undefined  && show_integration_section" title="Integration">
									<p class="text-uppercase d-flex mb-2 flex-wrap align-items-center">
										<strong class="h4 m-2">Integration {{organization_data.partner_id.name}}</strong>
									</p>

									 <div v-if="organization_data.partner_id.name == 'HHAexchange'">
										<HHAX-integration :integration_id="organization_data.partner_id.id"></HHAX-integration>
									</div>
									<div v-if="organization_data.partner_id.name == 'Viventium'">
										<viventium-integration  :integration_id="organization_data.partner_id.id"></viventium-integration>
									</div>
									<div v-if="organization_data.partner_id.name == 'AlayaCare'">
										<alayacare-integration  :integration_id="organization_data.partner_id.id"></alayacare-integration>
									</div>
								
							    </b-tab>
							    <b-tab title="Automation Rules">
									<div v-if="tabIndex == 7">
										<automation-dashboard></automation-dashboard>

									</div>
								
							    </b-tab>
								<b-tab  title="Import HHAs">
										<div class="col-12 col-xl-10">
											
										<h4 class="section-title">Import HHAs  
											<span v-if="organization_data && false"> for {{ organization_data.name }}</span>
										</h4>

										<p class="text-uppercase"><strong>User</strong></p>
							
										<div  class="white-content rounded mb-3 white-content">
											<v-select placeholder="Discipline" class="mb-2"  :searchable="true" label="name"
												v-model="disciplines_selected" :options="disciplines" multiple>
											</v-select>
										</div>
										<div  class="white-content rounded mb-3 white-content">
											<v-select placeholder="Location" class="mb-2"  :searchable="true" label="name" 
												v-model="location_selected" :options="locations">
											</v-select>
										</div>

										
										<p class="text-uppercase"><strong>Program</strong></p>
										<div>
										<div  class="white-content rounded mb-3 white-content">
											<!--<div class="custom-popover  custom-popover-left popover-top">
												<div class="m-0">
													<div class=" m-0">
														<strong class="h5 m-0">STEP 2.</strong>
														<p> Select one of the existing programs</p>
													</div>
												</div>
											</div>-->
											<v-select placeholder="Program" class="mb-2"  :searchable="true" @remove="resetProgramDetails"
												v-model="courses_selected" :options="courses_import" multiple>
											</v-select>
										</div>
						
										<div class="white-content rounded mb-3 white-content">
											<label>Program starting date</label>
											<date-picker class="date_picker_new" v-model="program_starting_date_selected"  name="program_starting_date" :range="false" :format="'MM/DD/YYYY'" 
												:placeholder="'Program starting date'" 
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'MM/DD/YYYY'"
												:disabled="courses_selected.length==0 ? true : false"
												v-validate="courses_selected.length>0 ? 'required' : '' "
												></date-picker>
											<span class="input-error-msg">{{ errors.first('program_starting_date') }}</span>
										</div>
										<div class="white-content rounded mb-3 white-content">
											<v-select
												v-model="duration_method_selected"
												v-validate="courses_selected.length > 0 ? 'required' : ''"
												class="mb-2"
												placeholder="Program duration method"
												:options="[
													{ id: '1', label: 'Beginning of the year following start date' },
													{ id: '2', label: 'One year from start date' },
													{ id: '3', label: 'One year from hire date' },
													{ id: '4', label: 'Program due date' },
												]"
												index="id"
												:disabled="courses_selected.length == 0 ? true : false"
												searchable
											></v-select>
										</div>
										<div v-if="duration_method_selected == '4'" class="white-content rounded mb-3 white-content">
											<label>Program duration date</label>
											<date-picker class="date_picker_new" v-model="program_duration_date_selected"  name="program_duration_date" :range="false" :format="'MM/DD/YYYY'" 
												:placeholder="'Program duration date'" 
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'MM/DD/YYYY'"
												:disabled="courses_selected.length==0 ? true : false"
												v-validate="courses_selected.length>0 ? 'required' : '' "
												></date-picker>
											<span class="input-error-msg">{{ errors.first('program_due_date') }}</span>
										</div>
									</div>
									<div class="checkbox-container squared mb-2">
										<input id="checkbox-send-welcome-sms" type="checkbox" v-model="send_welcome_sms_notif"/>
										<label for="checkbox-send-welcome-sms" style="width:auto;">Notify new HHAs</label>
									</div>
									<div>
										<div class="checkbox-container squared mb-4">
											<input id="checkbox-override-dates" type="checkbox" v-model="override_dates"/>
											<label for="checkbox-override-dates" style="width:auto;">Override dates for existing employees</label>
										</div>
									</div>
									<p class="text-uppercase"><strong>Import HHAs</strong></p>
										<div class="relative">
											<vue-dropzone ref="dropzone" id="dropzone" class="mb-3"
												:options="dropzoneOptions"
												@vdropzone-success="fileUploaded" @vdropzone-file-added="fileAdded">
											</vue-dropzone>

											<!--
											<div class="dropzone-overlay" v-if="courses_selected.length < 1">
												<div>To upload a file you have to select a program first.</div>
											</div>
										-->
										</div>
										<a :href="api_base + 'NevvonSampleImportTemplate.xlsx'" class="text-underline">Click here to download template with dummy data</a>

										<div v-if="import_result != null">
											<h5>Results</h5>
											<table  class="table table-bordered">
												<thead>
													<th class="green-content orderable">New HHAs</th>
													<th class="green-content orderable">Already in the system</th>
													<th class="green-content orderable">Errors</th>
												</thead>
												<tbody>
													<tr>
														<td>{{ import_result.unique_providers }}</td>
														<td>{{ import_result.repeated_providers }}</td>
														<td>{{ import_result.errors }}</td>
													</tr>
												</tbody>
											</table>
											<table  class="table table-bordered">
												<thead>
													<th class="green-content orderable">Row</th>
													<th class="green-content orderable">Status</th>
													<th class="green-content orderable">Errors</th>
												</thead>
												<tbody>
													<tr v-for="row in import_result.logs">
														<td>{{ row.index }}</td>
														<td>{{ row.status }}</td>
														<td>
															<ul>
																<li v-for="error in row.message">
																	{{ error }}
																</li>
															</ul>

															<button v-if="row.status == 'ERROR'" @click="modalEditRow(row)">
																Edit
															</button>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</b-tab>
							  </b-tabs>
							</b-card>
						</div><!--col-->
					</div><!--row-->
				</div><!--col-->
			</div><!--row-->

		</div><!--container-->
		
		<!-- ADD NEW HHA -->
	    <b-modal v-model="show_add" title="Add HHA" size="lg">
			<p class="mb-2">
				<button  class="bold button green-content large-button text-uppercase" @click="new_provider = !new_provider">
					<span v-if="!new_provider">Create a new HHA</span>
					<span v-else>Select from list</span>
				</button>
			</p>
			<p class="mt-4">
				<span v-if="!new_provider">...Or select from list:</span>
				<span v-else>Create HHA</span>
			</p>
			

			<div v-if="!new_provider">
				<div class="row justify-content-between align-items-end mb-2">
					<div class="col-12 col-md-4">
						<div class="input-content no-border m-0 ml-2">
							<input class="m-0" v-model="search_all_providers" placeholder="Search by name/ssn" type="text" 
									@keyup="getAllProviders()" />
						</div>
					</div><!--col-->
					<div class="col-12 justify-content-end col-md-4 mb-1 col-lg-4 d-flex align-items-center">
						<small class="mr-2">Per page:</small>
						<multiselect v-model="all_providers_table.per_page" :options="[10, 25, 50, 100]" @select="changePerPageAllProviders"
							:allow-empty="false" :show-labels="false"></multiselect>
					</div><!--col-->
				</div>

		    	<table class="table table-bordered">
					<thead>
						<tr>
							<th></th>
							<th class="green-content">SSN</th>
							<th class="green-content">Name</th>
							<th class="green-content">Email</th>
							<th class="green-content">Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in providers" >
							<td class="text-center">
								<router-link tag="a" :to="{ name: 'admin.providers.detail', params : { id : item.id } }" :style="{ 'background-image' : 'url(data:image/jpeg;base64,'+item.image+')' }" class="picture-container thumb-container"></router-link>
							</td>
							<td>{{ item.ssn }}</td>
							<td>
								<router-link :to="{ name :'admin.providers.detail', params : { id : item.id } }" tag="a" target="_blank">
									{{ item.first_name }} {{ item.last_name }}
								</router-link>
							</td>
							<td>{{ item.email }}</td>
							<td>

								<toggle-button v-model="item.in_organization" 
										:labels="{ checked : 'Remove', unchecked : 'Add'}" :width="100"
										:switchColor="{ checked : red, unchecked : green }"
										:color="{ checked : red, unchecked : green, disabled : '#CCCCCC' }"
										@change="toggleProvider(item)" :sync="true"/>

							</td>
						</tr>
					</tbody>
				</table>
				<div class="row justify-content-between">
					<div class="col-12 col-lg-6">
						Showing {{ all_providers_table.from }} to {{ all_providers_table.to }} of {{ all_providers_table.total }}
					</div><!--col-->
					<div class="col-12 col-lg-6">
						<b-pagination align="right" :total-rows="all_providers_table.total" v-model="all_providers_table.current_page" :per-page="parseInt(all_providers_table.per_page)" @change="setPageAllProviders">
			    	</b-pagination>
					</div><!--col-->
				</div><!--row-->
			</div>
			<div v-else>
				<form @submit.prevent="onSubmitNewProvider">
					<label class="mb-2 h5 green">1. PERSONAL INFO</label>
					<div class="lightgray-content p-3 rounded mb-2">
						<div class="row">

							<div class="col-12 col-lg-4 col-xl-3">
								<div class="form-group input-content">
									<label>IMAGE</label>

									<picture-input 
								      ref="pictureInput"
								      accept="image/jpeg,image/png" 
								      size="10" 
								      button-class="button"
								      :custom-strings="{
								        upload: '<h1>Bummer!</h1>',
								        drag: 'Drag or click to upload an image'
								      }"
								      @change="onChangeImgProvider"
								      >
								    </picture-input>

								</div>
							</div><!--col-->
							<div class="col-12 col-lg-4">
								<div class="form-group input-content">
									<label>Email</label>
									<input placeholder="Email" type="text" v-model="provider_data.email" class="form-control" v-validate="'email'" name="email">
									<span class="input-error-msg">{{ errors.first('email') }}</span>
								</div>
								<div class="form-group input-content">
									<label>First name</label>
									<input placeholder="First name" type="text" v-model="provider_data.first_name" class="form-control" v-validate="'required'" name="first_name">
									<span class="input-error-msg">{{ errors.first('first_name') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Last name</label>
									<input placeholder="Last name" type="text" v-model="provider_data.last_name" class="form-control" v-validate="'required'" name="last_name">
									<span class="input-error-msg">{{ errors.first('last_name') }}</span>
								</div>
								<!-- <div class="form-group input-content">
									<label>Gender</label>
									<v-select class="mb-2"  :searchable="false"  :options="[{ 'value' : 0, 'label' : 'Male' }, { 'value' : 1, 'label' : 'Female' }]" v-model="provider_data.gender">
									</v-select>
								</div> -->
							</div><!--col-->
							<div class="col-12 col-lg-4">
								<!-- <div class="form-group input-content">
									<label>Birthday</label>
									<datetime hidden-name="dob" placeholder="Birthday" v-model="provider_data.dob"></datetime>
									<span class="input-error-msg">{{ errors.first('dob') }}</span>
								</div> -->
								
								<div class="form-group input-content">
									<label>Telephone number</label>
									<input placeholder="Telephone number" type="text" v-model="provider_data.phone" class="form-control" name="phone"  v-validate="'required'">
									<span class="input-error-msg">{{ errors.first('phone') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Preferred language</label>
									<multiselect v-model="provider_data.preferred_language" :options="preferred_languages"></multiselect>
								</div>
								<div class="form-group input-content">
									<label>SSN</label>
									<input placeholder="SSN" type="text" v-model="provider_data.ssn" 
											class="form-control" v-validate="'required|numeric|length:9|ssn_unique'" name="ssn">
									<span class="input-error-msg">{{ errors.first('ssn') }}</span>
								</div>
							</div><!--col-->

							<!-- -->
							<div class="col-12 col-lg-3">
								
								<div class="form-group input-content">
									<label>Agency manager</label>
									<input placeholder="Email" type="text"  class="form-control" v-validate="'email'" name="lhcsa_manager"
											v-model="provider_data.lhcsa_manager">
									<span class="input-error-msg">{{ errors.first('lhcsa_manager') }}</span>
								</div>
							</div>
							<div class="col-12 col-lg-3">
								<div class="form-group input-content">
									<label>Coordinator</label>
									<input placeholder="Email" type="text"  class="form-control" v-validate="'email'" name="coordinator"
										v-model="provider_data.coordinator">
									<span class="input-error-msg">{{ errors.first('coordinator') }}</span>
								</div>
							</div>
							<div class="col-12 col-lg-3">
								<div class="form-group input-content">
									<label>Manager approving completion</label>
									<input placeholder="Email" type="text"  class="form-control" v-validate="'email'" 
									name="manager_approving_the_hha_score" v-model="provider_data.manager_approving_the_hha_score">
									<span class="input-error-msg">{{ errors.first('manager_approving_the_hha_score') }}</span>
								</div>
							</div>
							<div class="col-12 col-lg-3">
								<div class="form-group input-content">
									<label>Supporting RN</label>
									<input placeholder="Email" type="text" class="form-control" v-validate="'email'" name="supporting_rn"
										v-model="provider_data.supporting_rn">
									<span class="input-error-msg">{{ errors.first('supporting_rn') }}</span>
								</div>
							</div>
							<!-- -->
						</div><!--row-->
					</div>

					<div class="text-right mt-2 mb-5">
						<button type="submit" class="button large-button">Submit</button>
					</div>
				</form>
			</div>
		</b-modal>

    	<b-modal v-model="show_delete" title="Delete HHA" @ok="deleteProvider" cancel-title="No" ok-title="Yes">
	    	<div v-if="provider_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the HHA {{ provider_to_delete.first_name }} {{ provider_to_delete.last_name }}?
				</p>
			</div>
		</b-modal>

		<!-- modal manage programs -->
		<b-modal v-model="show_add_course" title="Add Program" size="lg" ok-only ok-title="Close" @ok="cleanProgramsAddTable">
		
			  <sme-table :table_body_data="all_courses" :table_headers="['ID','Program','Notes','Agencies','Modules','Created on','Actions']"
			    @searchCourses="getAllCoursesSearch"
                :table_view="'courses'"
				:view="'detail'"
                :pagination_existing_courses="all_courses_table"
                @setPageExistingCourses="setPageAllCourses"
				@toggleCourse="toggleCourse"
                ></sme-table>
			
		</b-modal>

		<!-- modal delete course -->
		<b-modal v-model="show_delete_course" title="Delete program" @ok="deleteCourse" cancel-title="No" ok-title="Yes">
	    	<div v-if="course_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the program {{ course_to_delete.name }} ?
				</p>
			</div>
		</b-modal>

		<!-- MODAL EDIT ROW -->
		<b-modal v-model="show_edit_row" title="Edit row" @ok="editRow()" cancel-title="Cancel" 
			ok-title="Edit"  size="lg">
			<form @submit.prevent="onSubmitEditRow">
		    	<div v-if="row_to_edit != null">

		    		<p>Row: {{ row_to_edit.index }}</p>
		    		<p>Errors</p>
		    		<ul>
			    		<li v-for="error in row_to_edit.message">
							{{ error }}
						</li>
					</ul>
				
					<div class="lightgray-content p-3 rounded mb-2">
						<div class="row">
							<div class="form-group input-content col-4">
								<label>Email</label>
								<input placeholder="Email" type="text" v-model="provider_data_row.email" class="form-control" v-validate="'email'" name="email">
								<span class="input-error-msg">{{ errors.first('email') }}</span>
							</div>
							<div class="form-group input-content col-4">
								<label>First name</label>
								<input placeholder="First name" type="text" v-model="provider_data_row.first_name" class="form-control" v-validate="'required'" name="first_name">
								<span class="input-error-msg">{{ errors.first('first_name') }}</span>
							</div>
							<div class="form-group input-content col-4">
								<label>Last name</label>
								<input placeholder="Last name" type="text" v-model="provider_data_row.last_name" class="form-control" v-validate="'required'" name="last_name">
								<span class="input-error-msg">{{ errors.first('last_name') }}</span>
							</div>

							<div class="form-group input-content col-4">
								<label>Country code</label>
								<v-select class="mb-2" name="country_code" :searchable="true" :options="country_codes" v-model="provider_data_row.country_code"
													v-validate="'required'">
											</v-select>
								<span class="input-error-msg">{{ errors.first('country_code') }}</span>
							</div>

							<div class="form-group input-content col-4">
								<label>Telephone number</label>
								<input placeholder="Telephone number" type="text" v-model="provider_data_row.phone" class="form-control" name="phone"  v-validate="'required|numeric|min:8|max:10'">
								<span class="input-error-msg">{{ errors.first('phone') }}</span>
							</div>

							<!-- <div class="form-group input-content col-4">
								<label>Gender</label>
								<v-select class="mb-2"  :searchable="false"  :options="[{ 'value' : 0, 'label' : 'Male' }, { 'value' : 1, 'label' : 'Female' }]" v-model="provider_data_row.gender">
								</v-select>
							</div> -->
							<!-- <div class="form-group input-content col-4">
								<label>Birthday</label>
								<datetime hidden-name="dob" placeholder="Birthday" v-model="provider_data_row.dob"></datetime>
								<span class="input-error-msg">{{ errors.first('dob') }}</span>
							</div> -->
							<div class="form-group input-content col-4">
								<label>Preferred language</label>
								<v-select class="mb-2"   :searchable="false"  :options="['English','Spanish']" v-model="provider_data_row.preferred_language">
								</v-select>
							</div>
							<div class="form-group input-content col-4">
								<label>SSN</label>
								<input placeholder="SSN" type="text" v-model="provider_data_row.ssn" 
										class="form-control" v-validate="'required|numeric|length:9'" name="ssn">
								<span class="input-error-msg">{{ errors.first('ssn') }}</span>
							</div>
						
							<div class="form-group input-content col-4">
								<label>LHCSA manager</label>
								<input placeholder="Email" type="text"  class="form-control" 
									v-validate="'required|email'" name="lhcsa_manager" 
										v-model="provider_data_row.lhcsa_manager">
								<span class="input-error-msg">{{ errors.first('lhcsa_manager') }}</span>
							</div>
							<div class="form-group input-content col-4">
								<label>Coordinator</label>
								<input placeholder="Email" type="text"  class="form-control" 
									v-validate="'required|email'" name="coordinator"
									v-model="provider_data_row.coordinator">
								<span class="input-error-msg">{{ errors.first('coordinator') }}</span>
							</div>
							<div class="form-group input-content col-4">
								<label>Manager approving the hha score</label>
								<input placeholder="Last name" type="text"  class="form-control" 
									v-validate="'required|email'" 
								name="manager_approving_the_hha_score" v-model="provider_data_row.manager_approving_the_hha_score">
								<span class="input-error-msg">{{ errors.first('manager_approving_the_hha_score') }}</span>
							</div>
							<div class="form-group input-content col-4">
								<label>Supporting RN</label>
								<input placeholder="Last name" type="text" class="form-control" 
									v-validate="'required|email'" name="supporting_rn"
									v-model="provider_data_row.supporting_rn">
								<span class="input-error-msg">{{ errors.first('supporting_rn') }}</span>
							</div>
							<div class="form-group input-content col-4">
								<label>On board date</label>
								<datetime hidden-name="dob" placeholder="On board date" v-model="provider_data_row.onboard_date"></datetime>
								<span class="input-error-msg">{{ errors.first('onboard_date') }}</span>
							</div>
							<div class="form-group input-content col-4">
								<label>Program starting date</label>
								<datetime hidden-name="dob" placeholder="Program starting date" v-model="provider_data_row.program_starting_date"></datetime>
								<span class="input-error-msg">{{ errors.first('program_starting_date') }}</span>
							</div>
							<div class="form-group input-content col-4">
								<label>Duration method</label>
								<v-select class="mb-2"  :options="['1', '2', '3']" v-model="provider_data_row.duration_method">
								</v-select>
							</div>
						</div><!--row-->
					</div>
				
				</div>

			</form>
		</b-modal>

		<!-- ADD NEW SUBROLE -->
		<div v-if="show_add_subrole">
		<b-modal v-model="show_add_subrole" title="Add User" ok-only ok-variant="secondary" hide-footer ok-title="Cancel">
			<!-- <form @submit.prevent="onSubmitNewSubrole"> -->
				<div class="lightgray-content p-3 rounded mb-2">
					<div class="row">
						
						<div class="col-6">
							<div class="form-group input-content">
								<label>Name</label>
								<input placeholder="First name" type="text" v-model="subrole_data.name" class="form-control"  v-validate="'required'" name="first_name">
								<span class="input-error-msg">{{ errors.first('first_name') }}</span>
							</div>
							
							<div class="form-group input-content">
								<label>Email</label>
								<input placeholder="Email" type="text" v-model="subrole_data.email" class="form-control"  v-validate="'required|email'" name="email_">
								<span class="input-error-msg">{{ errors.first('email_') }}</span>
							</div>
							</div>
							<div>
								<div class="form-group input-content">
									<access-list :view="'add'"
									@userAccessGroupChange="userAccessGroupChange" />
									<span v-if="subrole_data.access_group == null" class="input-error-msg mt-1">Access Group Required</span>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group input-content">
									<label>Roles</label>
									<v-select class="mb-2"  :searchable="true" multiple
									label="display_name" 
										v-model="subrole_data.organization_role" :options="organization_roles">
									</v-select>
									<span v-if="subrole_data.organization_role.length == 0" class="input-error-msg">Roles Required</span>
								</div>
							</div>
						<!--col-->
					</div><!--row-->
						<!-- -->
					

						<div class="text-right mt-2 mb-5 float-left">
							<button type="submit" class="button gray-content large-button" @click="closeUserAddModal">Cancel</button>
						</div>
						<div class="text-right mt-2 mb-5">
							<button type="submit" class="button large-button" :disabled="subrole_data.organization_role.length == 0"  @click="onSubmitNewSubrole">Create</button>
						</div>
					
				</div>
			<!-- </form> -->
		</b-modal>
		</div>
		<!-- EDIT SUBROLE -->
		<div v-if="show_edit_subrole">
		<b-modal v-model="show_edit_subrole" title="Edit User" ok-only ok-variant="secondary" ok-title="Cancel" hide-footer>
				<div class="lightgray-content p-3 rounded mb-2">
					<div class="row">
						<div class="col-6">
							<div class="form-group input-content">
								<label>Name</label>
								<input placeholder="Name" type="text" v-model="edit_user_data.name" class="form-control" v-validate="'required'" name="first_name_">
								<span class="input-error-msg">{{ errors.first('first_name_') }}</span>
							</div>
							<div class="form-group input-content">
								<label>Email</label>
								<input placeholder="Email" :disabled="true" type="text" v-model="edit_user_data.email" class="form-control">
								<span class="input-error-msg">{{ errors.first('email_edit_role') }}</span>
							</div>
						</div>
						<div>
							<div class="form-group input-content">
								<access-list :view="'edit'" :edit_user_selection="edit_user_data.access_group"
								@userAccessGroupChangeEdit="userAccessGroupChangeEdit" />
								<span class="input-error-msg mt-1" v-if="edit_user_data.access_group == null">Access Group Required</span>
							</div>
						</div>

						<div class="col-6">
							<div class="form-group input-content">
								<label>Roles</label>
								<v-select class="mb-2"  :searchable="true" multiple label="display_name"
									v-model="edit_user_data.organization_role" :options="organization_roles">
								</v-select>
								<span v-if="edit_user_data.organization_role.length == 0" class="input-error-msg">Roles Required</span>

							</div>
						</div>
						
						
					</div>

					<div class="text-right float-left mt-2 mb-5">
						<button class="button gray-content large-button" @click="closeUserEditModal">Cancel</button>
					</div>
					<div class="text-right mt-2 mb-5">
						<button type="submit"  :disabled="edit_user_data.organization_role.length == 0" class="button large-button" @click="onSubmitEditSubrole">Update</button>
					</div>
					
				</div>
			
		</b-modal>
		</div>
		

		<!-- DELETE SUBROLE -->
		<b-modal v-model="show_delete_subrole" title="Delete subrole" @ok="deleteSubrole" cancel-title="No" ok-title="Yes">
	    	<div v-if="subrole_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the subrole {{ subrole_to_delete.name }} ({{ subrole_to_delete.email }})?
				</p>
			</div>
		</b-modal>

		<!-- REPLACE SUBROLE -->
		<b-modal v-model="show_replace_subrole" title="Replace subrole" @ok="onSubmitReplace">

			<p class="mb-2">
				<button  class="bold button green-content large-button text-uppercase" @click="new_subrole = !new_subrole">
					<span v-if="!new_subrole">Create a new subrole</span>
					<span v-else>Select from list</span>
				</button>
			</p>
			<p class="mt-4">
				<span v-if="!new_subrole">...Or select from list:</span>
				<span v-else>Create subrole</span>
			</p>

			<template v-if="!new_subrole">
				<v-select class="mb-2"  :searchable="true" v-model="subrole_replace" :filter="false" :autocomplete="false"
					 :options="subroles_filtered" track-by="id" label="str">
				</v-select>
			</template>
			<template v-else>
				<form @submit.prevent="onSubmitReplace">
					<div class="lightgray-content p-3 rounded mb-2">
						<div class="row">
							<div class="col-12">
								<div class="form-group input-content">
									<label>First name</label>
									<input placeholder="First name" type="text" v-model="subrole_data.name" class="form-control" v-validate="'required'" name="first_name">
									<span class="input-error-msg">{{ errors.first('first_name') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Email</label>
									<input placeholder="Email" type="text" v-model="subrole_data.email" class="form-control" v-validate="'email|required'" name="email">
									<span class="input-error-msg">{{ errors.first('email') }}</span>
								</div>
								<div class="form-group input-content" v-show="false">
									<label>Type</label>
									<v-select class="mb-2"  :searchable="true"
										v-model="subrole_data.organization_role" :options="organization_roles">
									</v-select>
								</div>
							</div><!--col-->
							<!-- -->
							<div class="text-right mt-2 mb-5">
								<button type="submit" class="button large-button">Submit</button>
							</div>
						</div><!--row-->
					</div>
				</form>
			</template>
		</b-modal>

		<!-- modal order programs -->
		<b-modal v-model="show_sort_courses" title="Order Program" size="lg" @ok="onSubmitOrder">
			<h2>Programs</h2>

			<form @submit.prevent="onSubmitOrder" class="max-height-500">

				<template v-for="item in courses" >

					<div class="form-group input-content">
						<input placeholder="order" type="number" v-model="item.order" class="form-control" min="0" style="width:40px; text-align:center; display:inline-block">
						<span class="bold">{{ item.name }}</span>
					</div>
				</template>

			</form>
	    
		</b-modal>

		<b-modal v-model="show_move_to_course" title="Move to program" @ok="moveToCourse">
			<template v-if="course_to_move_selected != null">
				<p>Assign HHAs from program <strong> {{ course_to_move_selected.name }}</strong> to :</p>
			</template>
			
			<v-select class="mb-2"  :searchable="true" v-model="course_to_move_new_selected" :options="course_import_filtered">
			</v-select>				
		</b-modal>

		<!-- add discipline -->
		<b-modal v-model="new_taxonomy_modal" :title="add_taxonomy_title" ok-title="Submit"
		 @cancel="new_taxonomy_name = ''" @ok="createTaxonomy" :ok-disabled="new_taxonomy_name == ''"
		>
			<form @submit.prevent="createTaxonomy">
				<div class="lightgray-content p-3 rounded mb-2">
					<div class="row">
						<div class="col-12">
							<div class="form-group input-content">
								<label>{{current_taxonomy_field}} name</label>
								<input :placeholder="current_taxonomy_field" type="text" v-model="new_taxonomy_name" class="form-control" v-validate="'required'" name="taxonomy">
								<span class="input-error-msg" v-if="errors.first('taxonomy')">{{current_taxonomy_field}} is required</span>
							</div>							
						</div><!--col-->
					</div><!--row-->
				</div>
			</form>
		</b-modal>


		<!-- delete taxonomy value (discipline or location) -->

		<b-modal v-model="delete_taxonomy_modal" ok-title="Delete" :title="'Delete ' + delete_taxonomy_type" @ok="deleteTaxonomyValue">
			<p class="mb-2" v-if="taxonomy_value_to_delete != null">
				Are you sure you want to delete the {{ delete_taxonomy_type }} {{ taxonomy_value_to_delete.name }}?
			</p>
		</b-modal>

		<!-- edi taxonomy value (disciplone or location) -->
		<b-modal v-model="edit_taxonomy_modal" :title="'Edit ' + edit_taxonomy_type"
		 ok-title="Edit" @cancel="taxonomy_temp_value = ''" @ok="editTaxonomyValue"
		>
			<form @submit.prevent="editTaxonomyValue" v-if="taxonomy_value_to_edit != null">
				<div class="lightgray-content p-3 rounded mb-2">
					<div class="row">
						<div class="col-12">
							<div class="form-group input-content">
								<label>Name</label>
								<input placeholder="Name" type="text" v-model="taxonomy_temp_value" class="form-control" v-validate="'required'" name="edit_taxonomy_name">
								<span class="input-error-msg" v-if="errors.first('edit_taxonomy_name')">{{edit_taxonomy_type }} is required</span>
							</div>							
						</div><!--col-->
					</div><!--row-->
				</div>
			</form>
		</b-modal>
		<password-reset 
		:bulk_modals="bulk_modals"  :bulk_selection="bulk_selection"
		:type="'user'"
		@resetEmailModal="resetEmailModal"></password-reset>
		
		

	</div>
</template>


<script>
import { EventBus } from './../../../event_bus.js';
import PictureInput from 'vue-picture-input';
import PhoneCountryCode from '../../shared/inputs/PhoneCountryCode'
import AccessList from '../../shared/AccessList'
import AccessGroupTree from '../../shared/AccessGroupTree'
import ViventiumIntegration from './integration/ViventiumIntegration'
import HHAXIntegration from './integration/HHAXIntegration'
import AlayacareIntegration from './integration/AlayacareIntegration'
import AutomationDashboard from '../../automation/AutomationDashboard.vue'
import MixinSME from '../../sme/MixinSME'
import AgencyViewMixin from '../../shared/AgencyViewMixin'
import OrganizationReportComponent from '../../organizations/reports/OrganizationReportComponent'
import OrganizationReportListComponent from '../../organizations/reports/OrganizationReportListComponent'

export default {
	mixins: [MixinSME,AgencyViewMixin],
	props:{
		agency:{
			required: false,
			  default () {
				  var agency = {
					  id: this.$route.params.agency_id
				  }
				  return agency
				}
		},
		AgencyView:{
			required: false,
			default: false
		}
	},
	computed : {
		organization_data_purchased_hours:{
			 get () {
				//return this.secondsToHms(this.organization_data.hours.purchased.sec,true)
				return this.organization_data.purchased_hours
            },
            set (val) {
				// document.querySelector(".purchased_hours").style['width'] = val.length+1 + "ch";
                this.organization_data.purchased_hours = val            
            }
		},
		left_hours_percentage: function(){
			if(this.organization_data.hours.purchased == null || this.organization_data.hours.purchased.sec == 0 ){
				return 0
			}else{
				return Math.round((this.organization_data.hours.spent.sec / this.organization_data.hours.purchased.sec)*100)
			}
			
		},
		dataShow:{
			get(){
					let temp_arr = []
				if(this.dropZoneTable.failure === true){
					return this.update_result.slice(0, this.dropZoneTable.currentPage * this.dropZoneTable.perPage);

				}else{
					this.dataShow = []
					this.update_result.filter(e=>{
					if(e.success === 0){
						temp_arr.push(e)
					}
				})
				return temp_arr.slice(0, this.dropZoneTable.currentPage * this.dropZoneTable.perPage);
			
				}
			},
			set(){
				return this.dataShow
			}
			
			
			
		},
		subroles_filtered : function(){
			var result = [];

			for(var i in this.subroles){
				switch(this.subrole_active_tab){
					case 0 :
						if(this.subroles[i].type == 'coordinator')
							result.push(this.subroles[i]);
						break;

					case 1 : 
						if(this.subroles[i].type == 'manager')
							result.push(this.subroles[i]);

						break;

					case 2 :
						if(this.subroles[i].type == 'approve_rn')
							result.push(this.subroles[i]);
						break;

					case 3 : 
						if(this.subroles[i].type == 'supporting_rn')
							result.push(this.subroles[i]);
						break; 
				}
			}

			return result;
		},

		course_import_filtered : function(){
			var courses = [];

			if(this.course_to_move_selected){
				for(var i in this.courses_import){
					if(this.courses_import[i].value != this.course_to_move_selected.id)
						courses.push(this.courses_import[i]);
				}
			}

			return courses;
		},

		subroles_import : function(){
			var coordinator = [];
			var manager = [];
			var approve_rn = [];
			var supporting_rn = [];
			let result = {};
			for(var i in this.subroles){
				switch(this.subroles[i].type){
					case 'coordinator': 
						coordinator.push(this.subroles[i]);
						break;
					case 'manager': 
						manager.push(this.subroles[i]);
						break;
					case 'approve_rn': 
						approve_rn.push(this.subroles[i]);
						break;
					case 'supporting_rn': 
						supporting_rn.push(this.subroles[i]);
						break;
					default:
						break;
				}
			}
			result = {
					'coordinator' : coordinator,
					'manager' : manager,
					'approve_rn' : approve_rn,
					'supporting_rn' : supporting_rn
				}
			return result;
		}

	},
	watch: {
		subrole_active_tab: function(newval, oldval){
			this.subrole_data.orgniazation_role = this.subrole_types[newval]
		},
		show_replace_subrole: function(val){
			this.subrole_replace = null
		},
		tabIndex: function(index){
			switch(index){
				case 0:
					this.getHHATabData()
					this.section_query = 'providers'
					break;
				case 1:
					this.section_query = 'info'
					break;
				case 2:
					this.section_query = 'report'
					break;
				case 3:
					this.getProgramsTabData()
					this.section_query = 'programs'
					break;
				case 4:
					this.getRolesAndPermissionData()
					this.section_query = 'roles-permissions'
					break;
				case 5:
					this.getDisciplineTabData()
					this.section_query = 'disciplines'
					break;
				case 6:
					this.getLocationTabData()
					this.section_query = 'locations'
					break;
				case 7:
					this.section_query = 'automation'
					break;
				case 8:
					this.getImportTabData()
					this.section_query = 'import'
					break;
				case 9:
					this.section_query = 'integration'
					break;
			}
			window.history.pushState({},'',`/csm/agency/${this.id}/${this.section_query}`)
		}
	},
	mounted(){
		EventBus.$on('agency_tab_changed', (e) =>{
			 let view_section = e.split('/')
			 this.agencyTabSet(view_section[view_section.length - 1])
		})
	},
	data : function(){
		return {
			section_query: 'providers',
			tabIndex: undefined,
			unique_table:0,
			csv_data:'',
			api_base : this.config.API_BASE,
			user_role:'',
			id : this.$route.params.agency_id,
			organization_data : {
				email : '',
				name : '',
				year_founded : '',
				became_costumer : '',
				providers : [],
				image : null,
				image_fill : null,
				phone : '',
				address : '',
				purchased_hours : ''
			},
			dropzoneOptions: {
				url: 'https://apitest.nevvon.com/admin/organizations/providers/update?organization_id=' + this.$route.params.agency_id,
				thumbnailWidth: 50,
				maxFilesize: 50,
				maxFiles : 1,
				addRemoveLinks : true,
				dictDefaultMessage: "Drop the agency image here" ,
				headers : {
					'Autrollization' : localStorage.getItem('token')
				},
				autoProcessQueue : false
		    },

			providers_table : {
				current_page : 0,
				total_rows : 0,
				per_page : 50,
				from : 0,
				to : 0
			},

			courses_table : {
				current_page : 0,
				total_rows : 0,
				per_page : 50,
				from : 0,
				to : 0
			},
			show_add : false,
			all_providers_table : {
				current_page : 0,
				total : 0,
				per_page : 50,
				from : 0,
				to : 0
			},
			providers : [],
			provider_to_delete : null,
			show_delete : false,
			
			courses : [],
			all_courses : [],
			all_courses_table_search:'',
			all_courses_table :{
				current_page : 0,
				total : 0,
				per_page : 20,
				from : 0,
				to : 0
			},
			show_add_course : false,
			red : this.config.COLORS.RED,
			green : this.config.COLORS.GREEN,
			course_to_delete : null,
			show_delete_course : false,
			search_providers : '',
			search_all_providers : '',
			search_courses : '',
			UpdateZoneMessage:'',
			

			years : [],
			new_provider : false,
			provider_data : {
				ssn : '',
				first_name : '',
				last_name : '',
				// dob: '',
				email : '',
				// gender: '',
				preferred_language: '',
				phone: '',
				image : null,
				organization_id : this.$route.params.id
			},
			preferred_languages : [],
			courses_import : [],
			courses_selected : [],
			location_selected : null,
			disciplines_selected : [],
			subroles_selected : [],
			program_starting_date_selected : '',
			program_duration_date_selected: '',
			duration_method_selected : '',
			program_selected : [],
			dropzoneOptions: {
				url : this.config.UPLOAD_ORGANIZATION_PROVIDERS_CSV + '?organization_id='+this.$route.params.id,
				thumbnailWidth: 50,
				maxFilesize: 50,
				maxFiles : 1,
				addRemoveLinks : true,
				headers : {
					'Autrollization' : localStorage.getItem('token')
				}
			},
			dropzoneOptionsUpdate: {
				url : this.config.UPDATE_ORGANIZATION_PROVIDERS_CSV+'?organization_id='+this.$route.params.id,
				thumbnailWidth: 50,
				maxFilesize: 50,
				maxFiles : 1,
				addRemoveLinks : true,
				headers : {
					'Autrollization' : localStorage.getItem('token')
				}
			},
			dropZoneTable:{
				 perPage:10,
				currentPage:1,
				 rows:'',
				 from:'',
				 to:'',
				 dataShow:[],
				 failure: true,
				 current_rows:''
			},
			toggle_status: true,

			updateZoneOptions: {},
		    message : '',
			import_result : null,
			update_result: [],
			update_result_fails:[],
		    row_to_edit : null,
			show_edit_row : false,
			provider_data_row : {
				ssn : '',
				first_name : '',
				last_name : '',
				// dob: '',
				// gender: '',
				preferred_language: '',
				phone: '',
				duration_method : '',
				employee_number : '',
				hha_registry_number : '',
				lhcsa_manager : '',
				manager_approving_the_hha_score : '',
				onboard_date : '',
				program_starting_date : '',
				supporting_rn : '',
				country_code : {
					label : '+1',
					value : '+1',
					name : 'United States'
				}
			},
			country_codes : [],
			time_zones : [],
			time_zone_selected : null,

			subroles : [],
			show_add_subrole : false,
			show_edit_subrole : false,
			show_replace_subrole : false,
			subrole_replace : null,
			replace_subrole : {
				subrole_id : null,
				email : null,
				name : null,
				type : {
					label : 'Coordinator',
					value : 'coordinator'
				}
			},
			new_subrole : false,
			subrole_data : {
				email : '',
				name : '',
				organization_role : '',
				access_group: null
			},
			subrole_to_edit : {
				email : '',
				name : '',
				organization_role : ''
			},
			edit_user_data :{
				organization_role: []
			},
			subrole_to_delete : null,
			subrole_to_replace : null,
			show_delete_subrole : false,
			subrole_config : [],
			subrole_types : [
				{
					label : 'Access Control',
					value : 'Access Control',
					table_headers: ['']
				},
				{
					label : 'Users',
					value : 'Users',
					table_headers: ['Name', 'Email', 'Role', 'Active', 'Actions']
				},
				// {
				// 	label : 'Roles',
				// 	value : 'Roles',
				// 	table_headers: ['Role Name', 'Number of Users', 'Actions']
				// },
				// {
				// 	label : 'Learner support',
				// 	value : 'supporting_rn'
				// }
			],
			show_sort_courses : false,
			subrole_active_tab : 0,

			show_move_to_course : false,
			course_to_move_selected : null,
			course_to_move_new_selected : null,
			send_welcome_sms_notif : false,
			override_dates: false,

			disciplines : [],
			locations : [],

			new_discipline : false,
			new_location : false,
			new_taxonomy_name : '',
			new_location_name : '',
			delete_taxonomy_type : '',
			delete_taxonomy_modal : false,
			taxonomy_value_to_delete : null,
			delete_taxonomy_modal : false,
			taxonomy_value_to_edit : null,
			edit_taxonomy_type : '',
			edit_taxonomy_modal : false,
			taxonomy_temp_value:'',
			add_taxonomy_title:'',
			new_taxonomy_modal:false,
			current_taxonomy_field:'',

			organization_users:[],

	
			bulk_selection : [],
			bulk_modals:{
				show_reset_password_email: false,
				show_reset_password_plain: false
			},
			open_tree_modal:false,
			organization_roles:[],
			
			user_meta_actions: localStorage.getItem('meta_actions'),
			integration_list:[],
			temp_partner_id:'',
			show_integration_section: false,
			actual_integrated_partner: ''


		}
	},

	components: {
		PictureInput,
		PhoneCountryCode,
		AccessList,
		AccessGroupTree,
		ViventiumIntegration,
		HHAXIntegration,
		AlayacareIntegration,
		AutomationDashboard,
		OrganizationReportComponent,
		OrganizationReportListComponent
	},
	created : function(){
		// window.addEventListener('beforeunload', function(event) {
		// 	this.$router.push({ name :'csm.providers.info', params : { agency_id : this.id}});
			
		// })
		//check if it is refreshed page -  go to the last tab
		
		if(this.$route.params.tab_section){
			this.agencyTabSet(this.$route.params.tab_section)
		}

		this.user_role = this.$store.getters.getRole
		//get organization all the time
		this.getOrganization();
		this.getPartners();
    	//Info Tab
		this.getInfoTabData();


		//this.getOrganizationRoles();
		this.getAllProviders();	

		//Programs Tab
		//this.getCourses();	

		//this.getPreferredLanguages();

		//Import Tab
		//this.getCoursesForImport();
		// this.getCountries();
		// this.getTimeZones();
		// this.getSubroles();

		//Location
		//this.getLocations();

		//Disciplines
		//this.getDisciplines();
		//this.getPartners();

		for(var i = 1900; i<2021;i++){
			this.years.push(i);
		}
		// this.agencyTabSet('providers')

	},

	methods : {
		agencyTabSet(event){
			this.tabIndex = this.redirectUrl(event)
		},
		openAddCourseModal(){
			this.getAllCourses();	
			this.show_add_course = !this.show_add_course
		},
		getRolesAndPermissionData(){
			this.getSubroles();
			this.getOrganizationRoles();
		},
		getProgramsTabData(){
			this.getCourses()
		},
		getDisciplineTabData(){
			this.getDisciplines()
		},
		getLocationTabData(){
			this.getLocations()
		},
		getHHATabData(){
			this.getProviders()
		},
		getImportTabData(){
			this.getCoursesForImport()
			this.getDisciplines()
			this.getLocations()
		},
		getInfoTabData(){
			this.getPartners();
			this.getCountries();
			this.getTimeZones();
			this.getPreferredLanguages();
		},
		getPartners: function(){
			if(this.integration_list.length != 0){
				return
			}
			var params = {
				filters:{
					page_loading : false
				}
			}
			this.$store.dispatch('getOrganizationPartners', params).then((res) => {
					if(this.integration_list.length == 0){
						Object.keys(res.data).map((key) => {
						this.integration_list.push(res.data[key])
						})
						this.integration_list.push({id:0, name: 'None'})
					}
					
					if(this.organization_data.partner_id){
						this.organization_data.partner_id = this.integration_list.find(
						elem => (elem.id == (this.organization_data.partner_id) || elem.id == (this.organization_data.partner_id.id))
						)
						
						this.temp_partner_id = this.organization_data.partner_id
						this.show_integration_section = true
					}
					
			
			}).catch((error) => {
					console.log(error);
			});
		},
		userAccessGroupChange(group){
			this.subrole_data.access_group = group
		},
		userAccessGroupChangeEdit(group){
			this.subrole_to_edit.access_group = group
		},
		closeTreeModal(){
			this.open_tree_modal = false
			// this.show_edit_subrole = true
		},
		closeUserAddModal(){
			this.show_add_subrole = false
			this.subrole_data = {
				email : '',
				name : '',
				organization_role :[],
				access_group:null
			}
		},
		closeUserEditModal(){
			this.show_edit_subrole = false
			this.subrole_to_edit = {
				email : '',
				name : '',
				organization_role :[],
				access_group:null
			}
		},
		/*
		This function opens the modal for reset password
			and assign bulk selection value to current selected provider
		*/
		resetPasswordSendEmail: function(item){
			this.bulk_selection.push(item)
			this.bulk_modals.show_reset_password_email = true
			
		},
		/*
		This function opens the modal for reset password
			and assign bulk selection value to current selected provider
		*/
		resetPasswordPlain: function(item){
			this.bulk_selection.push(item)
			this.bulk_modals.show_reset_password_plain = true

		},
		resetEmailModal: function(){
			this.bulk_selection = []
			this.bulk_modals = {
				show_reset_password_email: false,
				show_reset_password_plain: false
			}
		},
		openAddModal:function(modalName){
			this.new_taxonomy_modal = !this.new_taxonomy_modal
			this.current_taxonomy_field = modalName
			//modalName == 'Location' ? this.new_location = !this.new_location : this.new_discipline = !this.new_discipline
			this.add_taxonomy_title = 'Add ' + modalName
		},
		countryInput: function(val){
				this.organization_data.country_code = val
		},
		getOrganization : function(){

			var params = {
				id : this.id,
				filters:{
					page_loading: false
				}
			}

			this.$store.dispatch('getOrganization', params).then((res) => {
				this.organization_data = res.data.data;
				
				this.organization_data.image_fill = this.organization_data.image;
				this.organization_data.image = null;
				if(this.organization_data.partner_id){
					this.actual_integrated_partner = this.integration_list.find(
							elem => elem.id == this.organization_data.partner_id
							)
				}
				if(this.organization_data.time_zone != null){
					this.time_zone_selected = this.organization_data.time_zone
				}
					
				//this.getProviders();
			}).catch((error) => {
				console.log(error);
			});
		},
		getOrganizationRoles: function(){
			var params = {
				id : this.id,
				filters : {
					page_loading: false
				}
			}
			this.$store.dispatch('getOrganizationRoles', params).then((res) => {
				this.organization_roles = (res.data.data);
			
			}).catch((error) => {
				console.log(error);
			});
		},

		//check this is still iin use? 
		getSubroles : function(){
			var params = {
				id : this.id,
				filters : {
					page_loading: false
				}
			}

			this.$store.dispatch('getOrganizationSubroles', params).then((res) => {
				this.organization_users = res.data.data;
			}).catch((error) => {
				console.log(error);
			});
		},

		getProviders : function(){
				if(this.search_providers == undefined){
					this.search_providers = ''
				}
				var params = {
					filters : {
						page : this.providers_table.current_page,
						per_page : this.providers_table.per_page,
						search : this.search_providers,
						page_loading: false
					},
					id : this.id
				}
				
				this.$store.dispatch('getOrganizationProviders', params).then((res) => {
					
					this.organization_data.providers = res.data.data;

					this.providers_table.current_page = res.data.meta.current_page;
					this.providers_table.total_rows = res.data.meta.total;
					this.providers_table.per_page = res.data.meta.per_page;
					this.providers_table.from = res.data.meta.from;
					this.providers_table.to = res.data.meta.to;
					this.unique_table++;
				}).catch((error) => {
					console.log(error);
				});
			
		},

		getCoursesForImport : function(){
			var params = {
				id : this.id,
				filters : {
					to_select : true,
					per_page : 500,
					page_loading: false
				}
			}
			
			this.$store.dispatch('getOrganizationCourses', params).then((res) => {
				
				this.courses_import = res.data.data;
					
			}).catch((error) => {
				console.log(error);
			});
		},
		setPageProviders : function(page){
			this.providers_table.current_page = page;

			this.getProviders();
		},
		getAllProviders : function(page){
			var params = {
				filters : {
					page : this.all_providers_table.current_page,
					in_organization : this.id,
					search : this.search_all_providers,
					per_page : this.all_providers_table.per_page,
					page_loading: false
				},
				id : this.id
			}

			this.$store.dispatch('getProviders', params).then((res) => {
				this.providers = res.data.data;
				this.all_providers_table = res.data.meta;

			}).catch((error) => {
				console.log(error);
			});
		},
		setPageAllProviders : function(page){
			this.all_providers_table.current_page = page;

			this.getAllProviders();
		},
		cleanProgramsAddTable: function(){
			this.all_courses_table.current_page = 1;
			this.all_courses_table_search = ''
			EventBus.$emit('reset_seach_key')
			this.getAllCourses();
		},
		getAllCoursesSearch: function(val){
			this.all_courses_table.current_page = 1;
			this.all_courses_table_search = val
			this.getAllCourses();
		},
		setPageAllCourses : function(obj){
			this.all_courses_table.current_page = obj.page;
			this.getAllCourses();
		},
		setPageCourses : function(page){
			this.courses_table.current_page = page;
			this.getCourses();
		},
		addProvider : function(provider_id){
			console.log("From ADMIN Component");
			var params = {
				organization_id : this.id,
				provider_id : provider_id,
				create : false,
			}

			this.$store.dispatch('addProviderToOrganization', params).then((res) => {
				this.getProviders();
				this.getAllProviders();
			}).catch((error) => {
				console.log(error);
			});
		},
		deleteProvider : function(){
			var params = {
				organization_id : this.id,
				provider_id : this.provider_to_delete.id
			}

			this.$store.dispatch('deleteProviderFromOrganization', params).then((res) => {
				this.getProviders();
				this.getAllProviders();
			}).catch((error) => {
				console.log(error);
			});
		},
		showModalDelete : function(provider){
			this.provider_to_delete = provider;
			this.show_delete = true;
		},
		showModalDeleteCourse : function(course){
			this.course_to_delete = course;
			this.show_delete_course = true;
		},
		showModalDeleteSubrole : function(subrole){
			this.subrole_to_delete = subrole;
			this.show_delete_subrole = true;
		},
		showModalReplaceSubrole : function(subrole){
			this.subrole_to_replace = subrole;

			for(var i in this.subrole_types){
				if(this.subrole_types[i].value == this.subrole_to_replace.type){
					this.subrole_data.organization_role = this.subrole_types[i];
				}
			}
			
			this.show_replace_subrole = true;
		},

		deleteSubrole : function(){
			var params = {
				id : this.id,
				subrole_id : this.subrole_to_delete.id
			}

			this.$store.dispatch('deleteOrganizationSubrole', params).then((res) => {
				this.getSubroles();
			}).catch((error) => {
				console.log(error);
			});
		},
		showModalEditSubrole : function(subrole){
			this.subrole_to_edit = subrole;
			this.edit_user_data = this.subrole_to_edit
			this.show_edit_subrole = true;
		},
		onSubmitEditSubrole : function(){
		
			this.$validator.validateAll(['first_name_']).then((result) => {
				if(result){
					var params = {
						id : this.id,
						user_id: this.subrole_to_edit.id,
						name : this.subrole_to_edit.name,
						email : this.subrole_to_edit.email,
						access_group_id: this.subrole_to_edit.access_group.id,
						organization_role_ids : this.subrole_to_edit.organization_role.map(elem => elem.id)
					}
					this.$store.dispatch('editOrganizationSubrole', params).then((res) => {

						this.getSubroles();
						this.show_edit_subrole = false;
						this.subrole_to_edit = null;
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		},
		setSubroleAsDefault : function(subrole){

			var params = {
				id : this.id,
				subrole_id : subrole.id
			}

			this.$store.dispatch('setDefaultOrganizationSubrole', params).then((res) => {
				this.getSubroles();
			}).catch((error) => {
				console.log(error);
			});
		},

		toggleMandatory : function(subrole_type){
			var params = {
				id : this.id,
				subrole_type : subrole_type
			}

			this.$store.dispatch('toggleMandatoryOrganizationSubrole', params).then((res) => {
				this.getSubrolesConfig();
			}).catch((error) => {
				console.log(error);
			})

		},
		getCourses : function() {

			var params = {
				id : this.id,
				filters : {
					page : this.courses_table.current_page,
					per_page : this.courses_table.per_page,
					search : this.search_courses,
					order: true,
					page_loading: false
				}
			}
			
			this.$store.dispatch('getOrganizationCourses', params).then((res) => {
				//this.courses = res.data.data;
				let courses_with_zero_order = res.data.data.filter(el => el.order == 0)
				this.courses = res.data.data.filter(el => el.order != 0)
				this.courses = this.courses.sort(function(a, b){
					return a.order> b.order
				})
				this.courses = this.courses.concat(courses_with_zero_order)
				this.courses_table = res.data.meta;
			}).catch((error) => {
				console.log(error);
			});
		},
		getAllCourses : function(){
			var params = {
				filters : {
					in_organization : this.id,
					page : this.all_courses_table.current_page,
					per_page : this.all_courses_table.per_page,
					search : this.all_courses_table_search
				}
			}
			this.$store.dispatch('getCourses', params).then((res) => {
				this.all_courses = res.data.data;
			
				for(var i in this.all_courses){
					this.$set(this.all_courses[i], 'in_organization', this.all_courses[i].in_organization);
				}

				this.all_courses_table = res.data.meta;
				//per page returns string I will convert to number
				this.all_courses_table.per_page =
				parseInt(this.all_courses_table.per_page);
		
			}).catch((error) => {
				console.log(error);
			});
		},

		//http://vee-validate.logaretm.com/v2/api/validator.html#properties
		onSubmit : function(){
			this.$validator.validateAll(['name','agency_contact_name', 'agency_contact_email', 'phone', 'admin_email', 'address', 'purchased_hours']).then((result) => {
				if(result){
					if(typeof this.organization_data.country_code == 'object' && this.organization_data.country_code){
						this.organization_data.country_code = this.organization_data.country_code.value;
					}
					if(this.temp_partner_id ){
						if(typeof this.temp_partner_id == 'object'){
							this.organization_data.partner_id = this.temp_partner_id.id
						}else{
							this.organization_data.partner_id = this.temp_partner_id
						}
					}
					if(this.time_zone_selected){
						this.organization_data.time_zone_id = this.time_zone_selected.id
					}
					this.$store.dispatch('editOrganization', this.organization_data).then((res) => {
						
						//this.$router.push({ name : 'admin.organizations.index' });
						// if(res.data.organization.partner_id){
						// 	this.organization_data.partner_id = this.integration_list.find(
						// 	elem => elem.id == this.organization_data.partner_id
						// 	)
						// 	this.temp_partner_id = this.organization_data.partner_id
						// 	this.actual_integrated_partner = this.organization_data.partner_id
						// 	this.show_integration_section = true
						// }
						this.getOrganization()
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		},

		toggleCourse : function(course){
			//addOrganizationToCourse
			//deleteCourseFromOrganization
			if(course.in_organization){
				var params = {
					filters : {},
					id : course.id,
					organization_id : this.id
				}

				this.$store.dispatch('addOrganizationToCourse', params).then((res) => {
					this.getAllCourses();
					this.getCourses();
					this.getCoursesForImport();
				}).catch((error) => {
					console.log(error);
				});
			}else{
				var params = {
					filters : {},
					id : this.id,
					course_id : course.id
				}

				this.$store.dispatch('deleteCourseFromOrganization', params).then((res) => {
					this.getAllCourses();
					this.getCourses();
					this.getCoursesForImport();
				}).catch((error) => {
					console.log(error);
				});
			}

		},
		toggleProvider : function(provider){
			if(provider.in_organization){
				this.addProvider(provider.id);
			}else{
				this.provider_to_delete = provider;
				this.deleteProvider();
			}
		},
		deleteCourse : function(){
			var params = {
				filters : {},
				id : this.id,
				course_id : this.course_to_delete.id
			}

			this.$store.dispatch('deleteCourseFromOrganization', params).then((res) => {
				this.getAllCourses();
				this.getCourses();
			}).catch((error) => {
				console.log(error);
			});
		},
		changePerPage : function(value, id){

			this.providers_table.current_page = Math.ceil(this.providers_table.from/value);

			this.providers_table.per_page = value;
			this.page_loading = false;
			this.getProviders();
		},
		changeCoursesPerPage : function(value, id){

			this.courses_table.current_page = Math.ceil(this.courses_table.from/value);

			this.courses_table.per_page = value;
			this.page_loading = false;
			this.getCourses();
		},
		changePerPageAllProviders : function(value, id){

			this.all_providers_table.current_page = Math.ceil(this.all_providers_table.from/value);

			this.all_providers_table.per_page = value;
			this.page_loading = false;
			this.getAllProviders();
		},
		setImg : function(file, dataUrl){
			this.provider_data.image = dataUrl;
		},
		onChange (image) {
			if (image) {
				this.organization_data.image = image;
			}
		},
		getPreferredLanguages : function(){
			var params = {
				filters : {
					page_loading : false
				}
			}
			this.$store.dispatch('getPreferredLanguages', params).then((res) => {
				this.preferred_languages = res.data;
			}).catch((error) => {
				console.log(error);
			});
		},
		onChangeImgProvider (image) {
			if (image) {
				this.provider_data.image = image;
			}
		},
		onSubmitNewProvider : function(){
			this.$validator.validateAll(['first_name', 'email_']).then((result) => {

				if(result){
					// this.provider_data.gender = this.provider_data.gender.value;
					this.$store.dispatch('createProvider', this.provider_data).then((res) => {
						this.getProviders();
						this.show_add = false;

						this.provider_data = {
							ssn : '',
							first_name : '',
							last_name : '',
							// dob: '',
							email : '',
							// gender: '',
							preferred_language: '',
							phone: '',
							image : null,
							organization_id : this.id
						}

					}).catch((error) => {
						
					});
				}
			});
		},

		onSubmitNewSubrole : function(){
			this.$validator.validateAll(['first_name', 'email_']).then((result) => {

				if(result){
					
					var params = {
						id : this.id,
						name : this.subrole_data.name,
						email : this.subrole_data.email,
						organization_role_ids : this.subrole_data.organization_role.map(elem=>elem.id),
						access_group_id: this.subrole_data.access_group.id
					}

					this.show_add_subrole = false;
					
					this.$store.dispatch('createOrganizationSubrol', params).then((res) => {
						this.show_add_subrole = false;
						this.getSubroles();

						this.subrole_data = {
							name : '',
							email : '',
							organization_role: [],
							access_group:null
						}

					}).catch((error) => {
						console.log(error);
					});
				}
			});
		},

		onSubmitReplace : function(){
			this.$validator.validateAll().then((result) => {

				if(result || this.subrole_replace){
					
					var params = {
						id : this.id,
						subrole_id : this.subrole_to_replace.id == null ? undefined : this.subrole_to_replace.id,
						email : this.subrole_data.email,
						name : this.subrole_data.name,
						type : this.subrole_data.organization_role.value
					}

					if(this.subrole_replace)
						params.subrole_id_other = this.subrole_replace.id

					this.$store.dispatch('replaceOrganizationSubrole', params).then((res) => {
						
						this.subrole_data = {
							name : '',
							email : '',
							organization_role : [],
							access_group:null
						}
						this.subrole_replace = null
						this.show_add_subrole = false;
						this.getSubroles();

						

					}).catch((error) => {
						console.log(error);
					});
				}
			});
		},

		fileUploaded : function(file, response){
			this.message = response.message;
			this.import_result = response.import;
			this.$refs.dropzone.removeAllFiles();

			this.$router.push({
				name: 'admin.organizations.imports.detail', 
				params : { 
					id: this.id, 
					import_id : response.import.id 
				}
			});
		},
		fileAdded : function(file){

			var url = this.config.UPLOAD_ORGANIZATION_PROVIDERS_CSV+'?organization_id='+ 
					this.organization_data.id+'&courses=' ;

			for(var i in this.courses_selected){
				url += this.courses_selected[i].value +',';
			}

			url += '&send_welcome_sms=' + (this.send_welcome_sms_notif ? 1 : 0);

			url += '&override_dates=' + (this.override_dates ? 1 : 0);

			url += '&discipline=';
			for(var i in this.disciplines_selected){
				url += this.disciplines_selected[i].name +',';
			}
			
			if(this.location_selected){
				url += '&location=' + this.location_selected.name;
			}

			for(var i in this.subroles_selected){
				url+='&' + i + '=' + this.subroles_selected[i].email;
			}

			if(this.program_starting_date_selected){
				url+= '&program_starting_date=' + this.program_starting_date_selected;
			}

			if(this.duration_method_selected){
				url+= '&duration_method=' + this.duration_method_selected;
			}
			if(this.duration_method_selected == '4'){
				url+= '&program_due_date=' + this.program_duration_date_selected
			}

			this.$refs.dropzone.setOption('url',url);
		},

		resetProgramDetails : function(){
			if(this.courses_selected.length==0)
			{
				this.program_starting_date_selected = '';
				this.duration_method_selected = '';
				this.program_duration_date_selected = '';
			}
		},

		toggleProviderUpdate: function() {
			//Update current page to 1
			this.dropZoneTable.currentPage = 1
			this.$refs.tables.loadDataShow();
		},
	// fileUploaded_update : function(file, response){
	// 	//Firtst we load the data and show the first page dataShow
	// 	if(response.data.length > 0){
	// 		this.update_result = response.data
	// 		this.csv_data = response.data
	// 		this.dataShow = this.update_result.slice((this.dropZoneTable.currentPage-1) * this.dropZoneTable.perPage, this.dropZoneTable.currentPage * this.dropZoneTable.perPage );
	// 		this.update_result.filter(e=>{
	// 		if(e.success === 0){
	// 			this.update_result_fails.push(e)
	// 		}
	// 		})
	// 		if( (this.update_result.length === this.update_result_fails.length ) || this.update_result_fails.length === 0){
	// 			this.toggle_status = false
	// 		}
	// 	this.dropZoneTable.rows = response.data.length;
	// 	this.UpdateZoneMessage = 'Results - '+response.message;
	// 	}else{
	// 		this.UpdateZoneMessage = "Nothing Have Changed"
	// 	}
	// 	this.$refs.dropzoneUpdate.removeAllFiles();
	// 	},
	failed(){
		const message = "This File is not supported";
		const elements = document.querySelectorAll('.dz-error-message span')
		const lastElement = elements[elements.length - 1]
		lastElement.textContent = message
		this.UpdateZoneMessage = "There is an error on the file";
		//this.$refs.dropzoneUpdate.removeAllFiles();

	},
	// fileAdded_update : function(file){
	// 		this.update_result = []
	// 		this.dataShow = []
	// 		this.update_result_fails = []
	// 		this.dropZoneTable.rows = []
	// 		this.UpdateZoneMessage = []
	// 		var url = this.config.UPDATE_ORGANIZATION_PROVIDERS_CSV+'?organization_id='+this.$route.params.id;
	// 		// for(var i in this.courses_selected){
	// 		// url += this.courses_selected[i].value +',';
	// 		// }
	// 		// url += '&send_welcome_sms=' + (this.send_welcome_sms_notif ? 1 : 0);
	// 		this.$refs.dropzoneUpdate.setOption('url',url);
	// 	},
		modalEditRow : function(row){
			this.row_to_edit = row;
			this.show_edit_row = true;
			this.provider_data_row = this.row_to_edit.row;
			// this.provider_data_row.dob = this.row_to_edit.row.birthday;
			this.provider_data_row.phone = this.row_to_edit.row.telephone_number;
		},
		editRow : function(){

			var params = {
				id : this.id,
				import_id : this.import_result.id,
				row_id : this.row_to_edit.id,
				data : this.row_to_edit
			}

			// params.data['birthday'] = params.data['dob'];
			this.$store.dispatch('editOrganizationImportLog', params).then((res) => {

				var params_ = {
					id : this.id,
					import_id : this.import_result.id,
					filters : {
						per_page : 100
					}
				}

				this.$store.dispatch('getOrganizationImportLogs', params_).then((res) => {
					this.import_result.logs = res.data.data; 
				}).catch((error) => {
					console.log(error);
				});

			}).catch((error) => {
				console.log(error);
			});
		},

		onSubmitEditRow : function(){

			this.$validator.validateAll().then((result) => {

				if(result){
					this.editRow();
				}
			});
		},
		getCountries : function(){
			var params = {
				filters : {
					page_loading : false
				}
			}
			this.$store.dispatch('getCountries', params).then((res) => {
			
				this.country_codes = res.data.data;
			}).catch((error) =>{	
				console.log(error);
			});
		},
		getTimeZones : function(){
			var params = {
				filters : {
					page_loading : false
				}
			}
			this.$store.dispatch('getTimeZones', params).then((res) => {
			
				this.time_zones = res.data.data;
			}).catch((error) =>{	
				console.log(error);
			});
		},

		// resetPassword : function(subrole){
		// 	var params = {
		// 		id : subrole.id,
		// 		filters : {
		// 			type : 'subrole'
		// 		}
		// 	}

		// 	this.$store.dispatch('sendResetPasswordEmail', params).then((res)=>{
		// 	}).catch((error) => {
		// 		console.log(error);
		// 	});
		// },
		// restorePassword : function(item){
		
		// 	let subrole_id = item.id
		// 	let old = !item.can_reset_password
		// 	var params = {
		// 		id : this.id,
		// 		subrole_id : subrole_id,
		// 		filters : {
		// 			old : old
		// 		}
		// 	}

		// 	this.$store.dispatch('restorePassOrganizationSubrole', params).then((res)=>{
		// 		this.getSubroles();
		// 	}).catch((error) => {
		// 		console.log(error);
		// 	});
		// },

		onSubmitOrder : function(){

			var params = {
				id : this.id,
				config : this.courses
			}

			this.$store.dispatch('orderOrganizationCourses', params).then((res) => {
				this.getCourses()

			}).catch((error) => {
				console.log(error);
			});
		},

		showModalMoveToCourse : function(course){

			this.course_to_move_selected = course;
			this.show_move_to_course = true;
		},

		moveToCourse : function(){

			this.$nextTick( () => {

				var params = {
					id : this.id,
					course_id : this.course_to_move_selected.id,
					destination_course_id : this.course_to_move_new_selected.value
				}

				this.$store.dispatch('addOrganizationCourseProgramFromTo', params).then((res) => {

					this.course_to_move_new_selected = null;
				}).catch((error) => {
					console.log(error);
				});
			});
		},

		toggleTaxonomyMandatory : function(type){

			var params = {
				id : this.organization_data.id,
				filters : {
					type : type
				}
			}

			this.$store.dispatch('toggleTaxonomyMandatory', params).then((res) => {
			}).catch((error) => {	
				console.log(error);
			})
		},

		getDisciplines : function(){
			var params = {
				id : this.id,
				filters : {
					type : 'discipline',
					page_loading: false
				}
			}

			this.$store.dispatch('getTaxonomyValues', params).then((res) => {
				this.disciplines = res.data.data;
			}).catch((error) => {
				console.log(error);
			});
		},

		getLocations : function(){
			var params = {
				id : this.id,
				filters : {
					type : 'location',
					page_loading: false
				}
			}
			this.$store.dispatch('getOrganizationLocation', params).then((res) => {
				this.locations = res.data.data;
			}).catch((error) => {
				console.log(error);
			});
		},

		createTaxonomy : function(){
			this.$validator.validateAll(['taxonomy']).then((result) => {

				if(result){
					var params = {
						id : this.organization_data.id,
						name : this.new_taxonomy_name,
						filters : {
							type : this.current_taxonomy_field[0].toLowerCase()+ this.current_taxonomy_field.slice(1)
						}
					}
					this.new_taxonomy_name = '';
					this.new_taxonomy_modal = false;

					this.$store.dispatch('createTaxonomyValue', params).then((res) => {
						this.current_taxonomy_field == 'Discipline' ? this.getDisciplines() : this.getLocations()
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		},

		modalDeleteTaxonomyValue : function(type, value){
			this.delete_taxonomy_type = type;
			this.delete_taxonomy_modal = true;
			this.taxonomy_value_to_delete = value;
		},
		deleteTaxonomyValue : function(){
			var params = {
				id : this.organization_data.id,
				value_id : this.taxonomy_value_to_delete.id,
				filters : {
					type : this.delete_taxonomy_type
				}
			}
			this.$store.dispatch('deleteTaxonomyValue', params).then((res) => {

				this.delete_taxonomy_modal = false;
				this.taxonomy_value_to_delete = null;

				this.getDisciplines();
				this.getLocations();

			}).catch((error) => {
				console.log(error);
			});
		},

		modalEditTaxonomyValue : function(type, value){
			this.edit_taxonomy_type = type;
			this.edit_taxonomy_modal = true;
			this.taxonomy_temp_value = value.name
			this.taxonomy_value_to_edit = value;
		},

		editTaxonomyValue : function(){
			var params = {
				id : this.organization_data.id,
				value_id : this.taxonomy_value_to_edit.id,
				name : this.taxonomy_temp_value,
				filters : {
					type : this.edit_taxonomy_type
				}
			}

			this.$store.dispatch('editTaxonomyValue', params).then((res) => {

				this.edit_taxonomy_modal = false;
				this.taxonomy_value_to_edit = null;

				this.getDisciplines();
				this.getLocations();

			}).catch((error) => {
				console.log(error);
			});
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/admin/organization/AdminOrganizationDetailComponent.vue